import { useMemo } from 'react';
import './WeekdaySelector.scss';
import { tLocal } from '../../../libraries/i18nLocal';

const WEEKDAY_ENTRIES: { value: number; key: string }[] = [
	{ value: 10, key: 'monday' },
	{ value: 20, key: 'tuesday' },
	{ value: 30, key: 'wednesday' },
	{ value: 40, key: 'thursday' },
	{ value: 50, key: 'friday' },
	{ value: 60, key: 'saturday' },
	{ value: 70, key: 'sunday' },
];

export function getWeekdayLabel(value: number): string {
    const entry = WEEKDAY_ENTRIES.find(e => e.value === value);
    return entry ? tLocal(`comocat.weekday.${entry.key}`) : String(value);
}

interface WeekdayType {
    value: number;
    display: string;
}

export interface WeekdaySelectorProps {
	selected?: number[];
	items?: WeekdayType[];
	onChange?: (selected: number[]) => void;
	multiple?: boolean;
	asRadio?: boolean;
}

export const WeekdaySelector = (props: WeekdaySelectorProps) => {
	const {
		selected, onChange, multiple, asRadio, items
	} = props;

	const _weekdays = useMemo(() => [
		...WEEKDAY_ENTRIES.map(e => ({ value: e.value, display: tLocal(`comocat.weekday.${e.key}`) })),
		...(items || []),
	], [items]);

	const onClick = (weekday: number) => {
		let _selected = [...(selected || [])];

		if (multiple) {
			const index = _selected.indexOf(weekday);
			if (index > -1 && (_selected.length > 1 || (_selected.length === 1 && !asRadio))) {
				_selected.splice(index, 1);
			} else {
				_selected.push(weekday);
			}
		} else {
			_selected = [weekday];
		}

		onChange?.(_selected);
	};

	return (
		<div className='WeekdaySelector'>
			{(_weekdays).map((weekday, index) => {
				return (
					<div
						key={`weekday-${index}`}
						onClick={() => onClick(weekday.value)}
						className={selected && selected?.indexOf(weekday.value) > -1 ? 'weekday selected' : 'weekday'}
					>
						{weekday.display}
					</div>
				);
			})}
		</div>
	);
};
